// ============================================================
// DefenceSurvivalChart - Survival curve with defence factored in, in blue.
// ============================================================
import type { DefenceSurvivalEstimate } from '../../engine/defenceProbability';
import SurvivalCurveChart from './SurvivalCurveChart';

export default function DefenceSurvivalChart({ data }: { data: DefenceSurvivalEstimate }) {
  return <SurvivalCurveChart data={data} colour="#60a5fa" />;
}
